module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (10).b1cbc433.jpg";